export const MiniQConfigAlertsValues = {
    sacc: 1,
    temp: 70,
    bat: 10,
    signal: -140,
};

export const MiniQConfigAlertsHas = {
    sacc: true,
    temp: true,
    bat: true,
    signal: true,
};
